import { render, staticRenderFns } from "./seaBookingHbl2.vue?vue&type=template&id=20c4d962&scoped=true&"
import script from "./seaBookingHbl2.vue?vue&type=script&lang=js&"
export * from "./seaBookingHbl2.vue?vue&type=script&lang=js&"
import style0 from "./seaBookingHbl2.vue?vue&type=style&index=0&id=20c4d962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c4d962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c4d962')) {
      api.createRecord('20c4d962', component.options)
    } else {
      api.reload('20c4d962', component.options)
    }
    module.hot.accept("./seaBookingHbl2.vue?vue&type=template&id=20c4d962&scoped=true&", function () {
      api.rerender('20c4d962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingHbl2.vue"
export default component.exports